import { render, staticRenderFns } from "./pickup.vue?vue&type=template&id=69f8161a&scoped=true"
import script from "./pickup.vue?vue&type=script&lang=js"
export * from "./pickup.vue?vue&type=script&lang=js"
import style0 from "./pickup.vue?vue&type=style&index=0&id=69f8161a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f8161a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f8161a')) {
      api.createRecord('69f8161a', component.options)
    } else {
      api.reload('69f8161a', component.options)
    }
    module.hot.accept("./pickup.vue?vue&type=template&id=69f8161a&scoped=true", function () {
      api.rerender('69f8161a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/pickup.vue"
export default component.exports